module.exports = __webpack_public_path__ + "static/media/bg_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg_1.png
// module id = 46
// module chunks = 0